import type { ModuleFederation } from '@module-federation/runtime';
import type { AfterInit } from '@vmok/rsbuild-plugin-early-runtime';

const afterInit: AfterInit<ModuleFederation> = ({ instance: mainInstance }) => {
  try {
    performance.mark('vmokRuntimeInit');
  } catch {}

  window.__TTAM_VMOK_MAIN_INSTANCE__ = mainInstance;
};

export default afterInit;
